import Box from '@mui/material/Box';
import { Typography } from '@mui/material';

export default function Footer() {
  return (
    <Box sx={{
      width: '100%',
      minHeight: '3rem',
      backgroundColor: 'background',
      borderTop: '1px solid #e0e0e0',
      p: 3,
      color: 'text',
      fontSize: '12px',
      fontWeight: 'bold',
      "& a": {
        color: 'text',
        textDecoration: 'none',
        "&:hover": {
          textDecoration: 'underline',
        }
      }
    }}>
      <Box sx={{ display: 'flex' }}>
        <Typography variant="body2" color="textSecondary">
          © Copyright Bullit.app {new Date().getFullYear()}. All rights reserved.
        </Typography>
      </Box>
    </Box>
  )
}